export default "__VITE_ASSET__91939949__"